import React, { FC } from 'react';
import { Badge, Box, SxProps, Typography } from '@mui/material';
import { i18n } from '../../i18n/i18n';
import CustomAvatar from '../CustomAvatar/CustomAvatar';
import { dateFormatter, numberPrettier } from '../../utils/formatters';

interface SocialCardProps {
    account: any;
    containerStyles?: SxProps;
}

const SocialCard: FC<SocialCardProps> = ({ account, containerStyles }) => {
    return (
        <Box
            className="card-shadow"
            sx={{
                p: '24px',
                borderRadius: '8px',
                width: '100%',
                ...containerStyles,
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', columnGap: '24px' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 247 }}>
                    <Badge
                        color="primary"
                        sx={{
                            'cursor': 'pointer',
                            '& .MuiBadge-badge': {
                                right: 123,
                                top: 74,
                                padding: '0 0px',
                                height: 0,
                                zIndex: 0,
                            },
                        }}
                        badgeContent={
                            <CustomAvatar
                                styles={{
                                    'zIndex': 1,
                                    '& .MuiBadge-badge': {
                                        right: 8,
                                        top: 40,
                                    },
                                }}
                                avatarSize={'48px'}
                                smallAvatarSize={'24px'}
                                avatar={{
                                    source: account.type.split(' ')[0],
                                    imgSrc: account.profileLocalPicture,
                                }}
                            />
                        }
                    >
                        <img
                            style={{ borderRadius: '4px' }}
                            src={
                                account.coverLocalPicture
                                    ? account.coverLocalPicture
                                    : require('../../../common/images/fallbacks/fallback.png')
                            }
                            alt=""
                            width="246"
                            height="75"
                        />
                    </Badge>
                    <Box sx={{ mt: 4.75, width: 247, textAlign: 'center' }}>
                        <Typography variant="s18w500">{account.name}</Typography>
                        <Typography>{account.userName}</Typography>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Box sx={{ display: 'flex' }}>
                        <Typography className="color-md">{i18n.translate('Joined')}:</Typography>
                        <Typography sx={{ ml: 1 }}>{dateFormatter(account.dateCreated)}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', mt: 1 }}>
                        <Typography className="color-md">{i18n.translate('Link')}:</Typography>
                        <Typography sx={{ ml: 1, lineBreak: 'anywhere' }}>{account.website}</Typography>
                    </Box>
                    <Box
                        sx={{
                            p: '11px 16px',
                            borderRadius: '8px',
                            mt: 'auto',
                            width: 256,
                            height: 75,
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                        className="background-color-mst"
                    >
                        <Box>
                            <Typography variant="s18w700">
                                {account.followingCount >= 0 ? numberPrettier(account.followingCount) : '-'}
                            </Typography>
                            <Typography className="color-md">{i18n.translate('Following')}</Typography>
                        </Box>
                        <Box>
                            <Typography variant="s18w700">
                                {account.followersCount >= 0 ? numberPrettier(account.followersCount) : '-'}
                            </Typography>
                            <Typography className="color-md">{i18n.translate('Followers')}</Typography>
                        </Box>
                        <Box>
                            <Typography variant="s18w700">
                                {account.postCount >= 0 ? numberPrettier(account.postCount) : '-'}
                            </Typography>
                            <Typography className="color-md">{i18n.translate('Posts')}</Typography>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', minWidth: 400 }}>
                    <Typography className="color-md">{i18n.translate('About')}:</Typography>
                    <Typography sx={{ ml: 1 }}>{account.description}</Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default SocialCard;
